import * as allThemeColors from "./themeColors";
import * as allColorNames from "../common/colorNames";
const Config = {
    name: 'Default Theme',
    className: 'trustar',
};
// This is a hacky workaround to deal with babel and export * as <alias>
const DefaultThemeConfiguration = {
    Config,
    ThemeColors: allThemeColors,
    ColorNames: allColorNames,
};
export { DefaultThemeConfiguration };
